// Centralized portfolio content for Nikita Singh — synced with attached resume.
export const PROFILE = {
  name: "Nikita Singh",
  tagline: "A Product Enthusiast",
  email: "nikitasingh2027@gmail.com",
  phone: "+91 7024 878 835",
  linkedin: "https://www.linkedin.com/in/nikita-singh-a4702625a",
  location: "Bengaluru",
  resumeUrl: "/Nikita-Singh-Resume.pdf",
  avatarUrl: "/avatar.jpg?v=7",
  bio:
    "Associate Product Manager with 1.5+ years of hands-on experience across PARK+ and WISHFY. Specialised in E-Commerce, PaaS and user-engagement products (gamification), with end-to-end execution, cross-functional collaboration and data-driven decision making.",
};

export const SKILL_GROUPS = [
  { title: "Product & Strategy", items: ["Product Management", "Roadmapping", "PRD", "Agile", "UAT"], variant: "peach" },
  { title: "Growth Domains", items: ["E-Commerce", "PaaS", "Gamification", "Product Launch"], variant: "lavender" },
  { title: "Design & Prototyping", items: ["Wireframing (Figma)", "Visily", "User Flow Optimization"], variant: "sage" },
  { title: "Data & Analytics", items: ["SQL", "Metabase", "MoEngage", "Excel", "Power BI", "Tableau"], variant: "peach" },
  { title: "Collaboration & Tools", items: ["Jira", "Confluence", "MS Office", "PowerPoint"], variant: "lavender" },
];

export const SKILLS = SKILL_GROUPS.flatMap((g) =>
  g.items.map((label) => ({ label, variant: g.variant }))
);

export const EXPERIENCE = [
  {
    company: "Wishfy Technology",
    role: "Associate Product Manager Intern",
    period: "Jan 2024 — Present",
    location: "Noida, India",
    accent: "peach",
    summary:
      "Owning E-Commerce + PaaS experiences end-to-end — from discovery to checkout, payments and post-launch retention.",
    tracks: [
      {
        title: "E-Commerce & Growth",
        points: [
          "Automated order tracking & shipping workflows by integrating system checks, enabling 3,237 monthly orders with fewer errors.",
          "Enhanced product search via filter & query-logic refinements — a 9% lift in order volume.",
          "Ran structured A/B tests on checkout flows: 7% conversion lift and 11% higher CTR.",
          "Redesigned app navigation with design team — checkout clicks 7 → 4, retention +17%.",
        ],
      },
      {
        title: "Payments & PaaS",
        points: [
          "Scoped & QA'd Razorpay integration: defined requirements, validated payment flows — 13% fewer failures, ₹1.97L monthly collections.",
          "Launched MVP for a gardening service by validating demand and shipping a test version — 23 bookings in 15 days.",
        ],
      },
    ],
  },
  {
    company: "Park+",
    role: "Product Management Intern",
    period: "Jun 2023 — Dec 2023",
    location: "Gurugram, India",
    accent: "sage",
    summary:
      "Drove product discovery, gamification and partnership launches across the Park+ consumer app.",
    tracks: [
      {
        title: "Discovery & Research",
        points: [
          "Conducted 217+ user interviews and competitor analysis to uncover gaps in parking and community features.",
          "Refined parking discovery filters & flows — 11% improvement in search-to-booking completion.",
        ],
      },
      {
        title: "Growth & Partnerships",
        points: [
          "Shipped 'Sell Car' partnership with CARS24 — drafted PRDs, wireframes, aligned design, engineering & external stakeholders for a smooth rollout.",
          "Launched additional quiz level in gamification — 5% lift in Day-2 retention.",
          "Designed in-app banners and placement experiments — 7% lift in feature adoption.",
        ],
      },
    ],
  },
];

export const EDUCATION = [
  {
    title: "Agentic AI Product Management",
    sub: "IIT Patna · Indian Institute of Technology",
    period: "Jun 2025 — May 2026",
    badge: "Certification",
    accent: "peach",
  },
  {
    title: "MBA (Masters of Business Administration)",
    sub: "BIT · Specialization: Finance",
    period: "Jun 2021 — Jun 2023",
    badge: "Degree",
    accent: "lavender",
  },
  {
    title: "Product Management: An Introduction",
    sub: "Coursera · IBM, SkillUp EdTech",
    period: "January 2023",
    badge: "Certificate",
    accent: "sage",
  },
];

export const PROJECTS = [
  {
    slug: "tapinvest-smart-reinvest",
    title: "Smart Reinvest — Tap Invest",
    blurb: "Turning every payout and maturity into the next investment — a product-led idea to move reinvestment adoption from 5% toward 20% on Tap Invest's Ultra app.",
    tags: ["Fintech", "Product Strategy", "User Flow", "Conversion"],
    externalLink: "/tapinvest/Tapinvest-Smart-Reinvest.pdf",
    externalLabel: "Download full deck",
    accent: "lavender",
    emoji: "📈",
    cover: "/tapinvest/slide-01.jpg",
  },
  {
    slug: "eureka-allen-free-trial",
    title: "Free Trial Productisation — Eureka by ALLEN",
    blurb: "Redesigned the 6-day free-trial into a clear, progress-led conversion experience for Class-10 board prep on ALLEN's Eureka app.",
    tags: ["EdTech", "Conversion", "Onboarding", "Product Teardown"],
    externalLink: "/eureka/Eureka-Summary.pdf",
    externalLabel: "Download summary PDF",
    accent: "peach",
    emoji: "🎓",
    cover: "/eureka/image-1-1.jpg",
  },
  {
    slug: "gardener-flow",
    title: "Imaginary Gardener Flow",
    blurb: "End-to-end wireframes for a gardener service booking experience — built and validated in Visily.",
    tags: ["Wireframing", "Visily", "Service Design"],
    externalLink: "https://app.visily.ai/projects/34b293ea-6579-4389-8ba5-659b14988b0b/boards/1270125",
    externalLabel: "View on Visily",
    accent: "sage",
    emoji: "🌱",
    cover: "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=1400&q=70",
  },
  {
    slug: "slice-bank-statement",
    title: "Savings Bank Statement on Slice App",
    blurb: "Integrated banking services that let users access and manage bank statements seamlessly inside Slice.",
    tags: ["Fintech", "User Research", "Integrations"],
    externalLink: "https://docs.google.com/document/d/1FEhTWB764IESriZBOGzq99AIS0GahL3YvUik7ds-3NE/edit",
    externalLabel: "Open case doc",
    accent: "peach",
    emoji: "🏦",
    cover: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=1400&q=70",
  },
  {
    slug: "kuku-fm-referral",
    title: "Referral Mechanism for Kuku FM",
    blurb: "Designed a referral system targeting 2,000 daily acquisitions with built-in anti-fraud measures.",
    tags: ["Growth", "Gamification", "Anti-fraud"],
    externalLink: "https://docs.google.com/document/d/1NTqrADwNWfh8hVc67EL-dBViqLnmsjYxRtnA5FDaUz8/edit",
    externalLabel: "Open case doc",
    accent: "lavender",
    emoji: "🎧",
    cover: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=1400&q=70",
  },
];

// Deep-dive case studies — keyed by slug
export const CASE_STUDIES = {
  "tapinvest-smart-reinvest": {
    title: "Smart Reinvest — Tap Invest",
    subtitle:
      "A product-led reinvestment experience for Tap Invest's Ultra app — turning every payout and maturity moment into the next confident investment decision.",
    role: "Product Strategy & UX (case study)",
    duration: "1 week · solo",
    tools: ["Figma", "User Flow Design", "Fintech UX", "Funnel Modelling"],
    cover: "/tapinvest/slide-01.jpg",
    sections: [
      {
        heading: "Problem",
        body:
          "Tap Invest's reinvestment adoption sits at just 5% (target 20%). The moment money lands back in a user's wallet or bank account after a payout or maturity, the investment journey ends. Four compounding issues: (1) the value of acting now is invisible — 'Reinvest on maturity' doesn't show what it's worth; (2) at payout, users don't know which eligible opportunity fits; (3) the decision comes too late — money has already left the investing surface; (4) auto-reinvest only fires on an exact match, otherwise everything gets credited to wallet/bank.",
      },
      {
        heading: "Users",
        body:
          "Retail fixed-income investors on Tap's Ultra platform who hold Invoice Discounting, Fixed Deposits, and Bonds. They care about their money working continuously, are comfortable with fixed-income products but often don't see reinvestment as a natural next step — because the product doesn't surface it as one. The wider ecosystem (Tap Partner, Tap Capital, BondScanner) already exists — the gap is at the investor's cash-flow moment.",
      },
      {
        heading: "Hypothesis",
        body:
          "If we prompt users before the payout hits (not after), project the future value of acting now, and surface 2-3 personalised reinvestment options with transparent yield/rating/tenure — reinvestment adoption will move meaningfully toward 20% because the decision moment is placed inside the investment surface, not at the wallet.",
      },
      {
        heading: "Wireframes",
        body:
          "I mapped a 3-screen flow per product (Invoice Discounting, FD monthly/quarterly/annually, Bonds): (1) Notify on payout — 'Your invoice payout is in 7 days. ₹77,562 will be credited' with Reinvest Now / Maybe Later; (2) Project the growth — 'Keep your money working' with a line-graph corpus projection over 30/60/90 days; (3) Choose where to reinvest — recommended options tagged 'Same as current FD', 'Higher returns', 'Higher rating', each showing XIRR/YTM, tenure, min-investment, payout frequency. If the user chooses not to reinvest, a trade-off view keeps the decision honest and theirs.",
      },
      {
        heading: "Solution",
        body:
          "Smart Reinvest — a proactive, transparent, user-controlled reinvestment flow. North-star: shift the framing from 'Reinvest on maturity' to 'Here's what your money can do next.' Every payout triggers Notify → Project → Choose → Confirm. Rules relax from exact-match auto-reinvest to guided, flexible recommendations. Bonus: I flagged a DigiLocker verification friction point observed during onboarding — a compounding drop-off worth fixing alongside the reinvestment surface.",
      },
    ],
    metrics: [
      { v: "5% → 20%", l: "reinvestment adoption target" },
      { v: "3 screens", l: "notify · project · choose" },
      { v: "3 products", l: "Invoice · FD · Bonds" },
    ],
    learnings:
      "Fixed-income users don't dislike reinvestment — they simply lose the moment. Placing the decision before the payout hits the wallet, and pairing it with a visible corpus projection, is the difference between a 5% adoption product and a 20% one. Auto-anything is not the answer; transparent guidance is.",
    extras: {
      images: [
        { src: "/tapinvest/slide-01.jpg", caption: "01 · Title — Smart Reinvest" },
        { src: "/tapinvest/slide-02.jpg", caption: "02 · What is Tap Invest? — product context" },
        { src: "/tapinvest/slide-03.jpg", caption: "03 · Problem — 5% today, 20% target" },
        { src: "/tapinvest/slide-04.jpg", caption: "04 · Opportunity map across products" },
        { src: "/tapinvest/slide-05.jpg", caption: "05 · Invoice Discounting flow — Notify · Project · Choose" },
        { src: "/tapinvest/slide-06.jpg", caption: "06 · FD monthly-payout flow" },
        { src: "/tapinvest/slide-07.jpg", caption: "07 · FD quarterly-payout flow" },
        { src: "/tapinvest/slide-08.jpg", caption: "08 · FD annual-payout flow" },
        { src: "/tapinvest/slide-09.jpg", caption: "09 · Bonds flow — yield · rating · tenure" },
        { src: "/tapinvest/slide-10.jpg", caption: "10 · DigiLocker onboarding friction — observed" },
        { src: "/tapinvest/slide-11.jpg", caption: "11 · Future-value hero — withdrawn vs reinvested" },
        { src: "/tapinvest/slide-12.jpg", caption: "12 · North-star — payout to confirmation" },
      ],
      downloads: [
        { label: "Full deck (PDF)", href: "/tapinvest/Tapinvest-Smart-Reinvest.pdf" },
      ],
      nikitaTake:
        "This one drew me in because the metric (5% adoption) hides a design failure, not a user failure. Tap has already earned the trust — the user has invested, waited, and is about to get paid. That's the highest-intent moment in a fixed-income journey. The current flow spends it silently: money lands in the wallet and the investing screen goes quiet. Smart Reinvest doesn't add a new product — it just moves the decision to where the user is already leaning forward. When you replace 'auto vs manual' with 'notify → project → choose', you get a growth lever and a UX win at the same time. That's the kind of product-led compounding I want to keep designing for.",
    },
    externalLink: "/tapinvest/Tapinvest-Smart-Reinvest.pdf",
    externalLabel: "Download full deck",
  },

  "eureka-allen-free-trial": {
    title: "Free Trial Productisation Strategy — Eureka by ALLEN",
    subtitle:
      "A product-led conversion strategy that transforms ALLEN's 6-day free trial from a timer-driven funnel into a structured, value-led learning experience for Class-10 board aspirants.",
    role: "Product Strategy & UX (teardown / case study)",
    duration: "1 week · solo",
    tools: ["Figma", "User Journey Mapping", "Competitive Teardown", "Funnel Modelling"],
    cover: "/eureka/image-1-1.jpg",
    sections: [
      {
        heading: "Problem",
        body:
          "Eureka's existing free trial leans heavily on a countdown timer to manufacture urgency — but offers no clear guidance on what the student gets for free, what they're paying for, or what they lose when the trial expires. The result: students bypass the trial's intended benefits, jump straight to checkout, hit decision fatigue (Free vs Paid? Play vs Enroll? What's actually included?), and drop off before they ever experience real value.",
      },
      {
        heading: "Users",
        body:
          "Class-10 board aspirants and their parents — first-time digital-learning buyers who care deeply about exam outcomes but are wary of online-course pricing. They want a continuous loop of watch → practice → track → clarify, and need confidence that the paid version is materially better than the free taste.",
      },
      {
        heading: "Hypothesis",
        body:
          "If we replace the timer-driven, decision-heavy trial with a structured, progress-tracked, transparently-priced 6-day experience that lets students actually feel the learning loop end-to-end, then trial-completion will rise — and trial-completers will convert to paid enrollments with much higher confidence (and fewer refunds / churn).",
      },
      {
        heading: "Wireframes",
        body:
          "I mapped the current (Confusion → Drop-Off) vs proposed (Clarity → Conversion) journeys and designed key surfaces: (1) a Trial Progress chip (\"0/2 Chapters Completed\") visible across the app; (2) a real-time Trial Status panel showing day-N-of-6, completed steps, and what's remaining; (3) context-aware CTAs that morph from \"Continue Trial\" mid-trial to \"Enroll Now to Unlock Full Learning\" post-trial; (4) a Full-Access value card (40+ lessons · 80+ practice sets · unlimited doubts) shown at the conversion moment.",
      },
      {
        heading: "Solution",
        body:
          "A 6-day structured trial: 2 chapters · 40 min of video · 20 practice questions · 1 doubt session — sequenced as Lesson → Quiz → Progress checkpoint → repeat. Progress-based engagement nudges land at Day 3 (\"1 chapter left — finish to unlock an exclusive enrollment discount\"), Day 5 (\"trial expires tomorrow — save your learning progress\"), and on completion (\"Unlock 40+ lessons, 80+ practice sets, unlimited doubts\"). The conversion is reframed: from a 1-time purchase into a 1-year subscription → continuous learning ladder.",
      },
    ],
    metrics: [
      { v: "6 days", l: "structured trial window" },
      { v: "2 → 1", l: "chapters to surface 'aha' moment" },
      { v: "3", l: "progress nudges across the trial" },
    ],
    learnings:
      "Urgency without clarity is just noise. Replacing a countdown timer with visible, completion-able milestones (chapters / quizzes) made the trial feel like real product value instead of a sales gate — and gave students an honest reason to enroll: they had already started learning.",
    extras: {
      images: [
        { src: "/eureka/image-1-1.jpg", caption: "Eureka by ALLEN — onboarding choice screen" },
        { src: "/eureka/image-2-1.jpg", caption: "Current Play-Store distribution surface" },
        { src: "/eureka/image-3-2.jpg", caption: "Mobile-number sign-up step" },
        { src: "/eureka/image-3-3.jpg", caption: "Verify CTA — current friction point" },
        { src: "/eureka/image-3-4.jpg", caption: "Course / chapter tile (illustrated)" },
        { src: "/eureka/image-5-1.jpg", caption: "Tutor recommendation surface" },
      ],
      downloads: [
        { label: "Summary (PDF)", href: "/eureka/Eureka-Summary.pdf" },
        { label: "Product Teardown (PPTX)", href: "/eureka/Eureka-Product-Teardown.pptx" },
      ],
      nikitaTake:
        "What pulled me into this teardown wasn't the timer — it was the gap between effort and confidence. Students were being asked to commit before they had a single completed milestone they could point to. The structured trial flips that: by the time the paywall appears, the student has already finished a chapter, attempted a quiz, and seen their own progress chip move from 0/2 → 1/2. The 'should I buy?' question quietly becomes 'I'm already learning here — why would I stop?'. That's the kind of product-led conversion I love designing for: where the funnel is the product, and the metric (enrollments) is a side-effect of the experience working.",
    },
    externalLink: "/eureka/Eureka-Summary.pdf",
    externalLabel: "Download full summary",
  },
  "gardener-flow": {
    title: "Imaginary Gardener Flow",
    subtitle: "Designing a frictionless way for urban renters to book a gardener — wireframed in Visily.",
    role: "Product Designer / PM (self-initiated)",
    duration: "2 weeks · solo",
    tools: ["Visily", "Figma", "User Interviews"],
    cover: "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=1600&q=70",
    sections: [
      {
        heading: "Problem",
        body:
          "Urban apartment dwellers and small-villa homeowners love their plants but lack the time, tools, or expertise to maintain them. Existing on-demand home-service platforms bundle gardening with unrelated services — making discovery clumsy and trust low.",
      },
      {
        heading: "Users",
        body:
          "Two primary segments emerged: (1) busy professionals with balcony gardens needing periodic upkeep; (2) elderly homeowners who can't manage physically demanding garden work themselves. Both value reliability and clear pricing over speed.",
      },
      {
        heading: "Hypothesis",
        body:
          "If we offer a dedicated, narrowly-scoped flow with transparent gardener profiles and fixed-price packages, users will trust the service enough to book within ≤ 3 minutes of opening the app.",
      },
      {
        heading: "Wireframes",
        body:
          "I sketched a 5-screen flow in Visily: (1) Hero with 'Book a gardener in 3 taps'; (2) Service type selector — Weekly trim · Repotting · Full setup; (3) Gardener cards with ratings, last-job photo, and ETA; (4) Date & address picker; (5) Confirm + Razorpay handoff.",
      },
      {
        heading: "Solution",
        body:
          "A focused booking funnel with social-proof gardener cards, fixed packages, and a single primary CTA on each step. Empty-state copy nudges users with seasonal suggestions ('Time for monsoon repotting?').",
      },
    ],
    metrics: [
      { v: "3 taps", l: "to confirm booking" },
      { v: "5 screens", l: "in MVP flow" },
      { v: "23", l: "bookings in 15-day validation" },
    ],
    learnings:
      "Narrow scope wins trust. The biggest lever was removing decision-fatigue — fixed packages outperformed flexible add-ons in user tests by 3x.",
    externalLink: "https://app.visily.ai/projects/34b293ea-6579-4389-8ba5-659b14988b0b/boards/1270125",
    externalLabel: "View wireframes on Visily",
  },
  "slice-bank-statement": {
    title: "Savings Bank Statement on Slice App",
    subtitle: "Bringing native bank-statement access into Slice so users never have to leave for their primary bank's app.",
    role: "Product Manager (case study)",
    duration: "3 weeks",
    tools: ["Figma", "User Research", "Competitive Analysis"],
    cover: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=1600&q=70",
    sections: [
      {
        heading: "Problem",
        body:
          "Slice users had to context-switch to their bank's app or net-banking portal every time they needed a savings-account statement (for rent receipts, tax filing, visa applications). This broke Slice's promise of being the single financial hub for young India.",
      },
      {
        heading: "Users",
        body:
          "Slice's core 22-28 year-old cohort — first-job earners, renters, and freelancers who need monthly/quarterly statements for landlords, accountants, and embassies but find traditional banking apps clunky.",
      },
      {
        heading: "Hypothesis",
        body:
          "If users can request, preview, and download a stamped bank statement directly inside Slice, time-to-statement will drop from 7+ minutes (external app) to under 60 seconds, increasing 30-day app retention.",
      },
      {
        heading: "Wireframes",
        body:
          "Designed three flows: (1) Quick statement — last 30 days, instant PDF; (2) Custom range with calendar picker; (3) Shareable view-only link for landlords / accountants with redacted account number.",
      },
      {
        heading: "Solution",
        body:
          "An 'Account → Statements' entry in the home tab with one-tap presets ('Last month', 'This FY', 'Custom'). Statements are pre-stamped server-side and shareable via a tokenized link that expires in 7 days.",
      },
    ],
    metrics: [
      { v: "< 60s", l: "from intent to download" },
      { v: "7 → 1", l: "min reduction" },
      { v: "3", l: "presets covering 80% of use-cases" },
    ],
    learnings:
      "Embedded micro-utilities (like statement access) drive disproportionate retention because they replace a small but recurring friction point users barely noticed they had.",
    externalLink: "https://docs.google.com/document/d/1FEhTWB764IESriZBOGzq99AIS0GahL3YvUik7ds-3NE/edit",
    externalLabel: "Read full case doc",
  },
  "kuku-fm-referral": {
    title: "Referral Mechanism for Kuku FM",
    subtitle: "A trust-built, fraud-resistant referral engine targeting 2,000 daily activated installs.",
    role: "Product Manager (case study)",
    duration: "4 weeks",
    tools: ["Figma", "Competitive Analysis", "Funnel Modelling"],
    cover: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=1600&q=70",
    sections: [
      {
        heading: "Problem",
        body:
          "Kuku FM's growth team needed a referral loop that delivered net-new listeners (not just farmed installs). Earlier referral attempts in the audio-content space suffered from heavy fraud — fake numbers, SIM farms, and uninstall-after-reward behaviour.",
      },
      {
        heading: "Users",
        body:
          "Tier-2/3 audio listeners aged 18-35 who consume devotional, romance, and self-help audio. They share heavily within close family/friends groups on WhatsApp — making organic, social-graph referrals especially valuable.",
      },
      {
        heading: "Hypothesis",
        body:
          "If we reward both referrer and referee with a meaningful, time-bound premium unlock (instead of cash), and gate rewards behind genuine listening behaviour, we can hit 2,000 verified activations/day while keeping fraud-rate < 5%.",
      },
      {
        heading: "Wireframes",
        body:
          "Designed: (1) Referrer hub with a personalised share card auto-generated per show; (2) Referee onboarding with social-proof ('your friend Riya gifted you 7 days Premium'); (3) Anti-fraud checkpoints — device-fingerprint, SIM-carrier check, and 'minimum 15 minutes listened in 48 hours' before reward unlocks.",
      },
      {
        heading: "Solution",
        body:
          "Two-sided premium-unlock incentive with progressive milestones for the referrer ('refer 3 to get 1 month free'). Anti-fraud combines passive device/IP signals with an active 'listened for 15 min' behavioural gate. Rewards drip-released over 7 days to reduce one-shot abuse.",
      },
    ],
    metrics: [
      { v: "2,000/day", l: "verified activations target" },
      { v: "< 5%", l: "fraud-rate ceiling" },
      { v: "15 min", l: "behavioural reward gate" },
    ],
    learnings:
      "Behavioural gates outperform identity gates for fraud prevention. Asking the user to *do* something genuine (listen for 15 min) is harder to spoof at scale than asking them to *be* someone (KYC).",
    externalLink: "https://docs.google.com/document/d/1NTqrADwNWfh8hVc67EL-dBViqLnmsjYxRtnA5FDaUz8/edit",
    externalLabel: "Read full case doc",
  },
};

export const HIGHLIGHTS = [
  { metric: "1.5+", label: "Years of PM experience" },
  { metric: "17%", label: "Retention lift @ Wishfy" },
  { metric: "₹1.97L", label: "Monthly collections enabled" },
  { metric: "217+", label: "User interviews conducted" },
];
